"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
const CHATSI_PROFILE_URL = 'https://perfiles.chatsi.net/android/profile.php?nick=';
const CHATSI_PHOTO_URL = 'https://perfiles.chatsi.net/fotos/';
var _default = exports.default = {
  components: {
    UserAvatar: _UserAvatar.default,
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['network', 'buffer', 'user', 'sidebarState'],
  data() {
    return {
      self: this,
      inviteChan: '',
      pluginUiButtonElements: _GlobalApi.default.singleton().userboxButtonPlugins,
      pluginUiInfoElements: _GlobalApi.default.singleton().userboxInfoPlugins,
      chatsiProfile: null,
      chatsiProfileLoading: false,
      chatsiProfileError: false,
      chatsiProfileRequestKey: '',
      chatsiPhotoOk: true,
      chatsiPhotoExpanded: false
    };
  },
  computed: {
    // Channel modes differ on some IRCds so get them from the network options
    availableChannelModes() {
      let availableModes = [];
      let prefixes = this.network.ircClient.network.options.PREFIX;
      let knownPrefix = {
        q: 'Owner',
        a: 'Admin',
        o: 'Operator',
        h: 'Half-Operator',
        v: 'Voice'
      };
      prefixes.forEach(prefix => {
        let mode = prefix.mode;
        if (knownPrefix[mode]) {
          availableModes.push({
            mode: mode,
            description: knownPrefix[mode]
          });
        }
      });
      return availableModes;
    },
    areWeAnOp() {
      if (!this.buffer) {
        return false;
      }
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    isUserOnBuffer() {
      if (!this.buffer) {
        return false;
      }
      if (!this.user.buffers[this.buffer.id]) {
        // Probably switched buffer while the userbox was open
        return false;
      }
      return true;
    },
    userMode: {
      get() {
        if (!this.buffer) {
          return '';
        }
        let userBufferInfo = this.user.buffers[this.buffer.id];
        if (!userBufferInfo) {
          // Probably switched buffer while the userbox was open
          return '';
        }
        let modes = userBufferInfo.modes;
        return modes.length > 0 ? modes[0] : '';
      },
      // Switch the current user mode for the new one
      set(newVal) {
        let client = this.network.ircClient;
        let oldVal = this.userMode;
        let changes = [];
        let targets = [];
        if (oldVal) {
          changes.push('-' + oldVal);
          targets.push(this.user.nick);
        }
        if (newVal) {
          changes.push('+' + newVal);
          targets.push(this.user.nick);
        }
        let params = ['MODE', this.buffer.name, changes.join('')].concat(targets);
        client.raw(params);
      }
    },
    isSelf() {
      return this.user === this.network.currentUser();
    },
    invitableBuffers() {
      let buffers = [];
      this.network.buffers.forEach(buffer => {
        if (buffer.isChannel() && buffer.isUserAnOp(this.network.nick) && !buffer.hasNick(this.user.nick)) {
          buffers.push(buffer.name);
        }
      });
      return buffers;
    },
    chatsiUsermask() {
      let username = this.user && this.user.username ? this.user.username : '';
      let host = this.user && this.user.host ? this.user.host : '';
      return `${username}@${host}`;
    },
    chatsiRegistered() {
      let username = this.user && this.user.username ? this.user.username : '';
      let beforeAt = String(username).split('@')[0];
      let match = beforeAt.match(/\.([01])$/);
      return !!match && match[1] === '1';
    },
    chatsiProfileNick() {
      let nick = this.user && this.user.nick ? String(this.user.nick) : '';
      return nick.replace(/^[~&@%+]+/, '').trim();
    },
    chatsiDisplayNick() {
      if (this.chatsiProfileOk && this.chatsiProfile.NICK) {
        return this.chatsiProfile.NICK;
      }
      return this.chatsiProfileNick || this.user && this.user.nick || '';
    },
    chatsiPhotoUrl() {
      return CHATSI_PHOTO_URL + encodeURIComponent(this.chatsiProfileNick.toLowerCase()) + '.jpg';
    },
    chatsiProfileOk() {
      return !!(this.chatsiRegistered && this.chatsiProfile && this.chatsiProfile.STATUS === 1);
    },
    chatsiDescription() {
      if (!this.chatsiProfileOk) {
        return '';
      }
      return this.cleanChatsiText(this.chatsiProfile.FRASE);
    },
    chatsiProfileViews() {
      if (!this.chatsiProfileOk) {
        return '';
      }
      let views = parseInt(this.chatsiProfile.VIEWS, 10);
      if (!views || views < 1) {
        return '';
      }
      return this.formatChatsiCompact(views);
    },
    chatsiInfoChip() {
      if (!this.chatsiProfileOk) {
        return '';
      }
      let age = this.cleanChatsiText(this.chatsiProfile.EDAD);
      let gender = this.cleanChatsiText(this.chatsiProfile.SEXO);
      let genderNorm = gender.toLowerCase();
      let ageAnon = this.isChatsiAnon(age);
      let genderAnon = this.isChatsiAnon(gender);
      if (ageAnon && genderAnon) {
        return '';
      }
      let suffix = '';
      if (!genderAnon) {
        if (genderNorm === 'hombre') {
          suffix = ' H';
        } else if (genderNorm === 'mujer') {
          suffix = ' M';
        } else if (genderNorm === 'no binario' || genderNorm === 'otro') {
          suffix = ' X';
        }
      }
      if (!ageAnon) {
        return age + suffix;
      }
      return gender;
    },
    chatsiCountryChip() {
      if (!this.chatsiProfileOk) {
        return '';
      }
      let country = this.cleanChatsiText(this.chatsiProfile.PAIS);
      if (this.isChatsiAnon(country)) {
        return '';
      }
      return country;
    },
    chatsiDateChip() {
      if (!this.chatsiProfileOk) {
        return '';
      }
      let rawDate = this.cleanChatsiText(this.chatsiProfile.ALTA);
      let digits = rawDate.replace(/\D+/g, '');
      if (!digits) {
        return '';
      }
      let days = parseInt(digits, 10);
      if (!days) {
        return '';
      }
      return this.formatChatsiDate(days);
    },
    chatsiHasChips() {
      return !!(this.chatsiInfoChip || this.chatsiCountryChip || this.chatsiDateChip);
    }
  },
  watch: {
    user() {
      // Reset the whois view since the user is now different
      this.resetChatsiProfile();
      this.loadChatsiProfileIfNeeded();
    },
    'user.username'() {
      this.resetChatsiProfile();
      this.loadChatsiProfileIfNeeded();
    },
    'user.host'() {
      this.resetChatsiProfile();
      this.loadChatsiProfileIfNeeded();
    }
  },
  mounted() {
    this.loadChatsiProfileIfNeeded();
  },
  methods: {
    openQuery() {
      this.sidebarState.showNicklist();
      let buffer = this.$state.addBuffer(this.network.id, this.user.nick);
      this.$state.setActiveBuffer(this.network.id, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('userbox.hide');
      }
    },
    updateWhoisData() {
      this.whoisRequested = true;
      this.whoisLoading = true;
      this.network.ircClient.whois(this.user.nick, () => {});
    },
    inviteUser() {
      if (!this.inviteChan) {
        return;
      }
      this.network.ircClient.invite(this.inviteChan, this.user.nick);
    },
    chatsiCloseUserbox() {
      this.$state.$emit('userbox.hide');
    },
    blockUser() {
      if (!this.user || this.isSelf) {
        return;
      }
      this.user.ignore = true;
    },
    togglePhotoExpanded() {
      this.chatsiPhotoExpanded = !this.chatsiPhotoExpanded;
    },
    resetChatsiProfile() {
      this.chatsiProfile = null;
      this.chatsiProfileLoading = false;
      this.chatsiProfileError = false;
      this.chatsiProfileRequestKey = '';
      this.chatsiPhotoOk = true;
      this.chatsiPhotoExpanded = false;
    },
    loadChatsiProfileIfNeeded() {
      if (!this.chatsiRegistered || !this.chatsiProfileNick) {
        return;
      }
      let requestKey = `${this.chatsiProfileNick}:${this.chatsiUsermask}`;
      if (this.chatsiProfileLoading && this.chatsiProfileRequestKey === requestKey) {
        return;
      }
      this.chatsiProfileLoading = true;
      this.chatsiProfileError = false;
      this.chatsiProfileRequestKey = requestKey;
      fetch(CHATSI_PROFILE_URL + encodeURIComponent(this.chatsiProfileNick.toLowerCase()), {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-store'
      }).then(res => {
        if (!res.ok) {
          throw new Error('profile_http_' + res.status);
        }
        return res.json();
      }).then(json => {
        if (this.chatsiProfileRequestKey !== requestKey) {
          return;
        }
        this.chatsiProfile = this.normalizeChatsiProfile(json);
        this.chatsiProfileLoading = false;
      }).catch(() => {
        if (this.chatsiProfileRequestKey !== requestKey) {
          return;
        }
        this.chatsiProfile = null;
        this.chatsiProfileLoading = false;
        this.chatsiProfileError = true;
      });
    },
    normalizeChatsiProfile(json) {
      let src = json || {};
      return {
        STATUS: parseInt(src.STATUS, 10) || -1,
        NICK: this.cleanChatsiText(src.NICK),
        PAIS: this.cleanChatsiText(src.PAIS),
        CIUDAD: this.cleanChatsiText(src.CIUDAD),
        SEXO: this.cleanChatsiText(src.SEXO),
        EDAD: this.cleanChatsiText(src.EDAD),
        ESTADO: this.cleanChatsiText(src.ESTADO),
        FRASE: this.cleanChatsiText(src.FRASE),
        ALTA: this.cleanChatsiText(src.ALTA),
        LIKES: this.cleanChatsiText(src.LIKES),
        VIEWS: this.cleanChatsiText(src.VIEWS)
      };
    },
    cleanChatsiText(value) {
      if (value === null || value === undefined) {
        return '';
      }
      return String(value).trim();
    },
    isChatsiAnon(value) {
      let v = this.cleanChatsiText(value).toLowerCase();
      return !v || v === 'anonimo' || v === 'anónimo';
    },
    formatChatsiDate(days) {
      if (days < 30) {
        return '-1 mes';
      }
      if (days < 365) {
        let months = Math.floor(days / 30);
        return '+' + months + (months === 1 ? ' mes' : ' meses');
      }
      let years = Math.floor(days / 365);
      return '+' + years + (years === 1 ? ' año' : ' años');
    },
    formatChatsiCompact(value) {
      let v = parseInt(value, 10) || 0;
      let abs = Math.abs(v);
      if (abs < 1000) {
        return String(v);
      }
      if (abs < 1000000) {
        return (v >= 0 ? '+' : '-') + Math.floor(abs / 1000) + 'k';
      }
      if (abs < 1000000000) {
        return (v >= 0 ? '+' : '-') + Math.floor(abs / 1000000) + 'M';
      }
      return (v >= 0 ? '+' : '-') + Math.floor(abs / 1000000000) + 'B';
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserBox"]
window._kiwi_exports.components.UserBox = exports.default ? exports.default : exports;
